// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1fkVu","inner":"Footer_inner__22CGB"};